import React from "react";
import {
  buildingPropertyLoan,
  carLoan,
  commercialBuilding,
  commercialVehicle,
  existingHomeLoan,
  homeExtension,
  homeRenovation,
  housePurchase,
  landLoan,
  lifeInsurance,
  NRIHomeLoan,
  plotPurchase,
  selfEmployee,
  solarLoan,
  twoWheelerLoan,
  unSecuredBusinessLoan,
  mortgageLoan,
  educationalLoan,
  newCommercialVehicleLoan,
  tractorLoan,
  residentialPropertyLoan,
  personalLoanSalaried,
  newTwoWheelerLoan,
  newCarLoan,
  generalInsurance,
  doctorLoan,
  constructionLoanIcon,
} from "../assets/Images";

const offerings = [
  { name: "Home Loans", icon: existingHomeLoan },
  { name: "Loan Against Property", icon: buildingPropertyLoan },
  { name: "Commercial Building Loan", icon: commercialBuilding },
  { name: "Existing Home Loan", icon: existingHomeLoan },
  { name: "Home Extension Loan", icon: homeExtension },
  { name: "Home Renovation Loan", icon: homeRenovation },
  { name: "House Purchase Loan", icon: housePurchase },
  { name: "Land Loan", icon: landLoan },
  { name: "Life Insurance Loan", icon: lifeInsurance },
  { name: "NRI Home Loan", icon: NRIHomeLoan },
  { name: "Plot Purchase Loan", icon: plotPurchase },
  { name: "Self Employee Loan", icon: selfEmployee },
  { name: "Solar Loan", icon: solarLoan },
  { name: "Unsecured Business Loan", icon: unSecuredBusinessLoan },
  { name: "Mortgage Loan", icon: mortgageLoan },
  { name: "Educational Loan", icon: educationalLoan },
  { name: "New Commercial Vehicle Loan", icon: newCommercialVehicleLoan },
  { name: "Used Commercial Vehicle Loan", icon: commercialVehicle },
  { name: "Tractor Loan", icon: tractorLoan },
  { name: "Residential Property Loan", icon: residentialPropertyLoan },
  { name: "Personal Loan Salaried", icon: personalLoanSalaried },
  { name: "New Two Wheeler Loan", icon: newTwoWheelerLoan },
  { name: "Used Two Wheeler Loan", icon: twoWheelerLoan },
  { name: "New Car Loan", icon: newCarLoan },
  { name: "Used Car Loan", icon: carLoan },
  { name: "General Insurance", icon: generalInsurance },
  { name: "Doctor Loan", icon: doctorLoan },
  { name: "Construction Loan", icon: constructionLoanIcon },
];

const OurOffering = () => {
  return (
    <div className="relative bg-[#f5f8fc] py-10 overflow-hidden w-full">
      <h1 className="text-center text-3xl font-bold">
        Our <span className="text-blue-800">Offerings</span>
      </h1>

      {/* Top & bottom shadows */}
      <div className="pointer-events-none absolute top-0 left-0 w-full h-8 bg-gradient-to-b from-black/10 to-transparent z-10" />
      <div className="pointer-events-none absolute bottom-0 left-0 w-full h-8 bg-gradient-to-t from-black/10 to-transparent z-10" />

      <div className="relative w-full overflow-x-hidden mt-8 group">
        <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused] mb-2">
          {offerings.concat(offerings).map((offering, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center w-32 sm:w-40 h-32 sm:h-40 bg-white mx-3 sm:mx-4 rounded-lg shadow-md hover:shadow-xl hover:border-2 hover:border-blue-600 transition-shadow duration-300 ease-in-out px-1"
            >
              {/* Icon stays fixed size and position */}
              <div className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 mb-2 sm:mb-4 flex items-center justify-center">
                <img
                  src={offering.icon}
                  alt={offering.name}
                  className="w-full h-full object-contain"
                />
              </div>

              {/* Name wraps nicely, does not push icon */}
              <p className="text-gray-700 text-xs sm:text-base font-medium text-center break-words px-1">
                {offering.name}
              </p>
            </div>

          ))}
        </div>
      </div>
    </div>
  );
};

export default OurOffering;

